(function () {
  'use strict';
  var root = document.querySelector('.elyone-home');
  if (!root) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    root.querySelectorAll('.elyone-home-reveal').forEach(function (el) { io.observe(el); });
  } else {
    root.querySelectorAll('.elyone-home-reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
